import React from "react";
import { observer } from "mobx-react-lite";

import { Currency } from "../currency";
import { useStore } from "../../../../hooks";
import { convertByCurrency } from "../../../../helpers";

interface AmountProps {
  amount: number; // amount by user currency
  currency?: string;
  isAdmin?: boolean;
  coinAmount: number; // amount by usd
  convertDifferentCurrency?: boolean;
}

export const Amount: React.FC<AmountProps> = observer(({ amount, currency, coinAmount, isAdmin, convertDifferentCurrency }) => {
    const { currenciesStore: { userCurrency, currenciesMap } } = useStore();

    const convert = isAdmin && userCurrency.name !== currency;

    const amountValue = convert ? coinAmount : amount;

    if (convertDifferentCurrency && convert) {
      const symbolOrName = userCurrency?.symbol || userCurrency.name;
      const defaultCurrencyRate = currenciesMap[currency || "USD"]?.rate;
      const amountByUSD = amount * defaultCurrencyRate;
      return <div>{`${symbolOrName} ${convertByCurrency(amountByUSD, convert ? userCurrency.rate || 1 : 1)}`}</div>
    }

    return (
      <Currency
        convert={false}
        value={amountValue}
        currencyCode={isAdmin ? userCurrency.name : currency}
      />
    );
  },
);
